import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useLevysList() {
    const toast = useToast()
    const records = ref(null)

    // Table Handler
    const columns = [
        {
            key: 'name', label: 'Levy Name', thStyle: { width: '25%' }, thClass: 'text-left', tdClass: 'text-left', sortable: true,
        },
        {
            key: 'value', label: 'Rate', thClass: 'text-right', tdClass: 'text-right', sortable: false,
        },
        {
            key: 'isPercentage', label: '% Rate?', thStyle: { width: '5%' }, thClass: 'text-right', tdClass: 'text-right', sortable: false,
        },
        { key: 'currency', label: 'Currency', sortable: false },
        { key: 'paySociety', label: 'Pay Entity', sortable: false },
        { key: 'ofWeight', label: 'Calculate From', sortable: false },
        {
            key: 'beneficiaries', label: 'Beneficiaries', thClass: 'text-right', tdClass: 'text-right', sortable: false,
        },
        {
            key: 'actions', label: 'Actions', thStyle: { width: '5%' }, thClass: 'text-right', tdClass: 'text-right',
        },
    ]

    const from = ref(0)
    const to = ref(0)
    const meta = ref({ from: 0, to: 0, total: 0 })
    const perPage = ref(10)
    const totalRecords = ref(0)
    const currentPage = ref(1)
    const perPageOptions = [5, 10, 25, 50, 100]
    const searchQuery = ref('')
    const sortBy = ref('name')
    const isSortDirDesc = ref(true)

    const refetch = () => {
        records.value.refresh()
    }

    watch([currentPage, perPage, searchQuery, sortBy, isSortDirDesc], () => {
        refetch()
    })

    const fetch = (ctx, callback) => {
        store
            .dispatch('cromis-levy/list', {
                query: searchQuery.value,
                per_page: perPage.value,
                page: currentPage.value,
                sortBy: sortBy.value,
                sortDesc: isSortDirDesc.value,
            })
            .then(response => {
                const { levies, meta } = response.data

                meta.value = meta

                callback(levies)
                totalRecords.value = meta.value.total
                from.value = meta.value.from
                to.value = meta.value.to
            })
            .catch(() => {
                toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Error fetching levies list',
                        icon: 'AlertTriangleIcon',
                        variant: 'danger',
                    },
                })
            })
    }

    return {
        fetch,
        columns,
        perPage,
        currentPage,
        totalRecords,
        from,
        to,
        meta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        records,

        refetch,
    }
}
